import React from "react";
import { Card, CardBody, CardTitle, Container } from "reactstrap";
import ApexCharts from "react-apexcharts"; 
import { getInspection } from "../../../Inspection/services/inspectionsApi";
import { getVehicules } from "../../../Vehicules/services/vehiculeApi";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

const InspectionIcidentVehicle = () => {
  const { data: vehicles = [] } = useQuery("vehicules", getVehicules);
  const { data: inspections = [] } = useQuery("inspections", getInspection);

  const getVehicleCountsByMonth = () => {
    const vehicleCounts = Array(12).fill(0); 
    vehicles.forEach(vehicle => {
      const createdAt = new Date(vehicle.createdAt);
      const month = createdAt.getMonth();
      if (month >= 0 && month < 12) {
        vehicleCounts[month] += 1; 
      }
    });
    return vehicleCounts;
  };
  const vehicleCountsByMonth = getVehicleCountsByMonth();

  const getInspectionCountsByMonth = () => {
    const inspectionCounts = Array(12).fill(0);
    inspections.forEach(inspection => {
      const createdAt = new Date(inspection.createdAt); 
      const month = createdAt.getMonth(); 
      if (month >= 0 && month < 12) {
        inspectionCounts[month] += 1; 
      }
    });
    return inspectionCounts;
  };
  const inspectionCountsByMonth = getInspectionCountsByMonth();

  const getIncidentCountsByMonth = () => {
    const incidentCounts = Array(12).fill(0); 
    inspections.forEach(inspection => {
      if (inspection.typeInspection === "Incident") {
        const createdAt = new Date(inspection.createdAt); 
        const month = createdAt.getMonth(); 
        if (month >= 0 && month < 12) {
          incidentCounts[month] += 1; 
        }
      }
    });
    return incidentCounts;
  };
  const incidentCountsByMonth = getIncidentCountsByMonth();
const {t}=useTranslation();
  const chartOptions = {
    chart: {
      type: 'line',
      height: '400px',
    },
    stroke: {
      curve: 'smooth',
      width: [2, 2, 2],
    },
    colors: ['#78ABA8', '#D5E76F', '#E87D00'],
    series: [
      {
        name: t("dashboard.vehicleEnregister"),
        data: vehicleCountsByMonth, 
      },
      {
        name: t("dashboard.incidentSurvenus"),
        data:incidentCountsByMonth, 
      },
      {
        name: t("dashboard.inspectionSoumises"),
        data: inspectionCountsByMonth, 
      },
    ],
    xaxis: {
      categories: [t("dashboard.jan"), t("dashboard.fev"), t("dashboard.mar"), t("dashboard.avr"), t("dashboard.mai"), t("dashboard.juin"), t("dashboard.juil"), t("dashboard.aou"), t("dashboard.sep"), t("dashboard.oct"), t("dashboard.nov"), t("dashboard.dec")], // Mois
    },
    yaxis: {
      title: {
        text: t("dashboard.number"),
      },
    },
    title: {
      text: "",
      align: 'center',
    },
  };

  return (
      <Card style={{ borderRadius: '15px' }}>
        <CardBody>
          <CardTitle tag="h5">{t("dashboard.graphic")}</CardTitle>
          <ApexCharts 
            options={chartOptions} 
            series={chartOptions.series} 
            type="line" 
            height="200"
          />
        </CardBody>
      </Card>
  );
};

export default InspectionIcidentVehicle;
